import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";

import {withStyles} from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
// import ListSubheader from '@material-ui/core/ListSubheader';
import Hidden from "@material-ui/core/Hidden";
// import Tooltip from "@material-ui/core/Tooltip";
// import tooltipsStyle from "assets/jss/material-kit-react/tooltipsStyle.jsx";

// import CustomizedDialogs from './OnHover';

import DeletePollBtn from 'components/Alerts/DeletePoll';

// const LightTooltip = withStyles(theme => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: 'rgba(0, 0, 0, 0.87)',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }))(Tooltip);

class PollGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navToPage: null,
    };
  }

  renderDeleteBtn(tile) {
    if (this.props.canDelete) {
      return (
        <GridListTileBar
          title={tile.question}
          actionIcon={
            <DeletePollBtn pid={tile.poll_id}/>
          }
        />
      );
    } else {
      return (
        <GridListTileBar
          title={tile.question}
        />
      );
    }
  }

  renderTiles = () => this.props.pollData.map(tile => {
    const {classes, history} = this.props;
    // TODO swap this with poll pals img as default
    const trump_img = "https://uploads-ssl.webflow.com/5b6dda309e9b6f542c3bda6d/5b6de85441c616e3796cd895_Asset%202trump.png";

    return (
      <GridListTile
        className={classes.gridTile}
        key={tile.poll_id}
        onClick={() => history.push(`/poll/${tile.poll_hash}`)}
      >
        <img
          // TODO change this to take the main url, we dont need a thumb!
          src={tile.thumb_url.includes('http') ? tile.thumb_url : trump_img}
          alt={tile.question}
        />
        {this.renderDeleteBtn(tile)}
      </GridListTile>
    );
  });

  render() {
    const {classes} = this.props;

    // possible screen sizes:   xs   |   sm   |   md   |   lg   |   xl
    // https://material-ui.com/layout/hidden/
    return (
      <div className={classes.root}>
        {/* one col on xs screen  */}
        <Hidden only={['sm', 'md', 'lg', 'xl']} implementation="css">
          <GridList cols={1} className={classes.gridList}>
            {this.renderTiles()}
          </GridList>
        </Hidden>
        {/* two cols on sm and md screen  */}
        <Hidden only={['xs', 'lg', 'xl']} implementation="css">
          <GridList cols={2} className={classes.gridList}>
            {this.renderTiles()}
          </GridList>
        </Hidden>
        {/* three cols on lg and xl screen  */}
        <Hidden only={['xs', 'sm', 'md']} implementation="css">
          <GridList cols={3} className={classes.gridList}>
            {this.renderTiles()}
          </GridList>
        </Hidden>
      </div>
    );
  }
}

PollGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  // ...tooltipsStyle,
  root: {
    // display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: '#fff',
  },
  gridList: {
    // width: 600,
    maxHeight: 640,
    display: 'flex',
  },
  gridTile: {
    "& > :first-child": {
      border: "1px solid #fff",
      transition: "all .2s",
    },
    "& > :first-child:hover": {
      transform: 'scale(1.05)',
      zIndex: 10,
      cursor: 'pointer',
    },
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
});

export default withRouter(withStyles(styles)(PollGrid));



// WEBPACK FOOTER //
// ./src/components/PollGrid/PollGrid.jsx